var WebWorker =
/** @class */
function () {
  function WebWorker(worker) {
    var code = worker.toString();
    var blob = new Blob(["(" + code + ")()"], {
      type: 'text/javascript'
    });
    return new Worker(URL.createObjectURL(blob));
  }

  return WebWorker;
}();

export default WebWorker;